/**
 * Canonical brand / restaurant cuisine values (Title Case).
 * Keep in sync with dashboard/src/constants/cuisines.js (Brand Management).
 */

export const CANONICAL_CUISINES = [
  "Chinese",
  "Japanese",
  "Korean",
  "Thai",
  "Indian",
  "Local",
  "Western",
  "Italian",
  "Snacks",
  "Fast Food",
  "Healthy",
  "Convenience",
  "Drinks",
  "Coffee",
  "Dessert",
  "Platform",
];

/** { value, label } for restaurant cuisine filter chips (value = API / brand field). */
export const BRAND_CUISINE_FILTER_OPTIONS = [
  { value: "Chinese", label: "🥡 Chinese" },
  { value: "Japanese", label: "🍣 Japanese" },
  { value: "Korean", label: "🍲 Korean" },
  { value: "Thai", label: "🍜 Thai" },
  { value: "Indian", label: "🍛 Indian" },
  { value: "Local", label: "🇲🇾 Local" },
  { value: "Western", label: "🍔 Western" },
  { value: "Italian", label: "🍝 Italian" },
  { value: "Snacks", label: "🍿 Snacks" },
  { value: "Fast Food", label: "🍟 Fast Food" },
  { value: "Healthy", label: "🥗 Healthy" },
  { value: "Convenience", label: "🏪 Convenience" },
  { value: "Drinks", label: "🥤 Drinks" },
  { value: "Coffee", label: "☕ Coffee" },
  { value: "Dessert", label: "🍰 Dessert" },
  { value: "Platform", label: "📱 Platform" },
];
